import { __makeTemplateObject } from "tslib";
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { color } from 'styled-system';
import styled from '@marvelapp/styled';
import { BAR_HEIGHT, colors, easings } from '@marvelapp/theme';
import ModalPortal from './ModalPortal';
import { hexToRGB } from './utils';
export default function ActionBar(_a) {
    var dataTestid = _a["data-testid"], children = _a.children, isOpen = _a.isOpen;
    var animation = {
        animate: {
            y: 0,
        },
        exit: {
            y: '100%',
        },
        initial: {
            y: '100%',
        },
        transition: {
            ease: easings.smooth.array,
            duration: 0.6,
        },
    };
    return (React.createElement(ModalPortal, null,
        React.createElement(AnimatePresence, null, isOpen && (React.createElement(Container, { animate: animation.animate, "data-testid": dataTestid, exit: animation.exit, initial: animation.initial, key: "action-bar", transition: animation.transition }, children)))));
}
var Container = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  pointer-events: all;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: ", "px;\n  background-color: ", ";\n  z-index: ", ";\n"], ["\n  ", ";\n  pointer-events: all;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: ", "px;\n  background-color: ", ";\n  z-index: ", ";\n"])), color, BAR_HEIGHT, hexToRGB(colors.black, 0.9), function (props) { return props.theme.zIndices.actionBar; });
var templateObject_1;
